import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "section home-page-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Projects", -1)
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column is-two-thirds" }
const _hoisted_6 = { class: "columns" }
const _hoisted_7 = { class: "column is-half my-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "EPs & Albums", -1)
const _hoisted_9 = { class: "column is-half my-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Singles", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)
const _hoisted_12 = { class: "column" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Links", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", { class: "navbar-divider" }, null, -1)
const _hoisted_15 = { class: "columns mb-2" }
const _hoisted_16 = { class: "column is-11 is-vcentered" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Media")
], -1)
const _hoisted_18 = { class: "level is-mobile" }
const _hoisted_19 = { class: "level-left" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "level-item" }
const _hoisted_22 = { class: "mx-2" }
const _hoisted_23 = { class: "image is-16x16" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "subtitle is-size-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", { class: "navbar-divider" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Social")
], -1)
const _hoisted_28 = { class: "level is-mobile" }
const _hoisted_29 = { class: "level-left" }
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "level-item" }
const _hoisted_32 = { class: "mx-2" }
const _hoisted_33 = { class: "image is-16x16" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "subtitle is-size-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaList = _resolveComponent("MediaList")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_MediaList, { isAlbum: true })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_MediaList, { isAlbum: false })
            ])
          ])
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaLinks, (mediaLink) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mb-4",
                  key: mediaLink.icon
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("a", {
                        href: mediaLink.url
                      }, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("img", {
                                src: 
                                require(`../assets/img/icons/${mediaLink.icon}`)
                              
                              }, null, 8, _hoisted_24)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_25, _toDisplayString(mediaLink.label), 1)
                        ])
                      ], 8, _hoisted_20)
                    ])
                  ])
                ]))
              }), 128)),
              _hoisted_26,
              _hoisted_27,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMediaLinks, (socialLink) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mb-4",
                  key: socialLink.icon
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("a", {
                        href: socialLink.url
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("img", {
                                src: 
                                require(`../assets/img/icons/${socialLink.icon}`)
                              
                              }, null, 8, _hoisted_34)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_35, _toDisplayString(socialLink.label), 1)
                        ])
                      ], 8, _hoisted_30)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}